var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#F8F9FA",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "Logout"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -11.96721,
    y: -7.21311,
    fill: "none",
    height: 40,
    width: 50,
    id: "area"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0.39485,12.94889a11.97,11.97 0 0 1 3.619,-8.636a1.171,1.171 0 0 1 1.5,0.1a1.1,1.1 0 0 1 0.106,1.466a9.925,9.925 0 0 0 0.132,14.21a10.52,10.52 0 0 0 14.557,0a9.924,9.924 0 0 0 0.132,-14.21a1.107,1.107 0 0 1 -0.433,-1.136a1.132,1.132 0 0 1 0.877,-0.857a1.162,1.162 0 0 1 1.164,0.422a11.967,11.967 0 0 1 3.62,8.636a12.642,12.642 0 0 1 -25.276,0l0.002,0.005zm11,3.332l0,-14.715a1.655,1.655 0 0 1 3.224,0l0,14.715a1.655,1.655 0 0 1 -3.224,0z",
    "data-name": "logout",
    id: "logout-2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.0901aa5b759500e53487839ea7538327.svg";
export { ForwardRef as ReactComponent };